import React, { ChangeEvent } from 'react';

export interface ICustom {
    type: string,
    componentName: string;
    onCustomChange: Function;
}

const CustomUIType = ({componentName, onCustomChange }: ICustom) => {
    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.currentTarget;
        onCustomChange({ type: 'custom', componentName: value });
    }

    return (
        <div className="slds-form-element">
            <label className="slds-form-element__label" htmlFor="text-input-id-2">
                <abbr className="slds-required" title="required">* </abbr>Component Name</label>
            <div className="slds-form-element__control">
                <input
                    role="componentName"
                    type="text"
                    id="text-input-id-2"
                    name="componentName"
                    required
                    value={componentName}
                    className="slds-input"
                    onChange={onChange}
                />
            </div>
        </div>
    );
}

export default CustomUIType;